import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { getFromLocalStorageAndDecrypt } from "../../Helpers/Chat/webChatEncryptDecrypt";
import { getHighlightedText } from "../../Helpers/Utility";
import ContactInfoCheckBox from "./ContactInfoCheckBox.js";
import Modal from "../WebChat/Common/Modal";
import BlockPopUp from "../WebChat/ConversationSection/PopUp/BlockPopUp";
import SDK from "../../SDK";
import { updateBlockedContactAction } from "../WebChat/ConversationSection/PopUp/BlockAction";
import { UNBLOCK_CONTACT_TYPE } from "../../Helpers/Chat/Constant";

const Contact = (props)=>{
    const { roster = {},contactBlock, contactName, image, thumbImage, emailId, statusMsg, status, isChanged = -1, searchValue, userId, userJid, prepareContactToAdd, prepareContactToRemove, hideCheckbox, maxMemberReached, isBlocked } = props
    const [selectState, setSelectState] = useState(false);
    const [showModal, setshowModal] = useState(false);
    const [blockId, setBlockId] = useState(null);
    const [nameToDisplay, setNameToDisplay] = useState(null);
    const updateJid = userId || userJid

    const handleChange = (e) => {
        if (!isBlocked) {
            const stateToUpdate = !selectState;
            if (maxMemberReached && stateToUpdate) {
                toast.error("Maximum " + getMaxUsersInCall() + " members allowed in a call");
                return;
            }
            setSelectState(stateToUpdate)
            if (stateToUpdate) {
                prepareContactToAdd(updateJid, props)
            } else {
                prepareContactToRemove(updateJid, props)
            }
        }
    };

    const popUpToggleAction = (userIds, nameToDisplays) => {
        setshowModal(!showModal);
        setBlockId(userIds ? userIds : null)
        setNameToDisplay(nameToDisplays ? nameToDisplays : null)
    };

    /* handleTempArchivedChats */

    const dispatchAction = async () => {
        setshowModal(!showModal);
        const res = await SDK.unblockUser(blockId);
        if (res && res.statusCode === 200) {
            updateBlockedContactAction(blockId, UNBLOCK_CONTACT_TYPE);
            toast.success(`${nameToDisplay || 'User'} has been Unblocked`);            
        }
    }

    useEffect(() => {
        if (isChanged === -1) {
            setSelectState(false)
            return
        }
        setSelectState(true)
    }, [isChanged])

    useEffect(() => {
        if (isBlocked) {
            setSelectState(false)
            prepareContactToRemove(updateJid, props)
        }
    }, [isBlocked])

    const token = getFromLocalStorageAndDecrypt('token');
    const hightlightText = getHighlightedText(contactName, searchValue)

    return (
        <React.Fragment>
            {showModal && <Modal containerId='container'>
                <BlockPopUp
                    popUpToggleAction={popUpToggleAction}
                    dispatchAction={dispatchAction}
                    headerLabel={<>{'Unblock'} {contactName} ?</>}
                    closeLabel={'Cancel'}
                    actionLabel={'Unblock'}
                    infoLabel={'On unblocking, this contact will be able to call you or send messages to you.'}
                />
            </Modal>}
            <ContactInfoCheckBox
                image={image}
                thumbImage={thumbImage}
                token={token}
                userId={userId}
                status={status}
                roster={roster}
                emailId={emailId}
                userJid={userJid}
                updateJid={updateJid}
                isBlocked={isBlocked}
                statusMsg={statusMsg}
                selectState={selectState}
                contactName={contactName}
                initialName={contactName}
                handleChange={handleChange}
                hideCheckbox={hideCheckbox}
                hightlightText={hightlightText}
                contactBlock={contactBlock}
                popUpToggleAction={popUpToggleAction}
            />
        </React.Fragment>
    )
}
export default Contact
